class CartSection extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    fetch(this.dataset.url)
      .then((response) => response.text())
      .then((html) => {
        document.getElementById("cart-section").innerHTML =
          this.getSectionInnerHTML(html, ".shopify-section");
      })
      .catch((e) => {
        console.error(e);
      });
  }

  renderContents(parsedState) {
    document.getElementById("cart-section").innerHTML =
      this.getSectionInnerHTML(
        parsedState.sections["mini-cart"]
      );
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }
}

customElements.define("cart-section", CartSection);
